<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <!-- Start the code for this screen here -->
        <div
          id="performance"
          class="container-fluid menu-margin-top"
          style="padding-left:0px;padding-right:0px"
        >
          <div>
            <div class="container-fluid">
              <div
                class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-2"
              >
                <div class="col d-flex justify-content-end align-items-center">
                  <label
                    id="salesAgentLabel"
                    class="col-form-label col-form-label-sm font-weight-bold"
                    >Salesperson</label
                  >
                </div>
                <!--col end-->
                <div class="col align-items-center">
                  <select
                    v-model="selectedagent"
                    id="myInput"
                    :disabled="salesAgentOnly"
                    class="form-control input-sm"
                  >
                    <option value="All">All</option>
                    <option
                      v-for="option in employeeList"
                      v-bind:value="option.employeeId"
                      >{{ option.firstName }}
                      {{
                        option.middleName.length != 0
                          ? "," + option.middleName
                          : ""
                      }}
                      , {{ option.lastName }}</option
                    >
                  </select>
                </div>
                <!--col end-->
                <div class="col d-flex justify-content-end align-items-center">
                  <label
                    id="monthLabel"
                    class="col-form-label col-form-label-sm font-weight-bold"
                    >Month</label
                  >
                </div>
                <!--col end-->
                <div class="col align-items-center">
                  <select
                    v-model="selectedmonth"
                    id="myInput"
                    class="form-control input-sm"
                  >
                    <option v-for="month in months">{{ month.month }}</option>
                  </select>
                </div>
                <!--col end-->
                <div class="col d-flex justify-content-end align-items-center">
                  <label
                    id="yearLabel"
                    class="col-form-label col-form-label-sm font-weight-bold"
                    >Year</label
                  >
                </div>
                <!--col end-->
                <div class="col align-items-center">
                  <select
                    v-model="selectedyear"
                    id="myInput"
                    class="form-control input-sm"
                  >
                    <option v-for="year in years">{{ year.year }}</option>
                  </select>
                </div>
                <!--col end-->
              </div>
              <!--row end-->
              <center>
                <button
                  v-on:click="searchScoreDetails()"
                  class="btn btn-secondary ml-3"
                >
                  Search
                </button>
                <button disabled="true" class="btn btn-secondary ml-3">
                  Export Score Card
                </button>
              </center>
            </div>
            <br />
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Scorecard Summary</b>
              </span>
            </nav>
            <div class="row mt-2 justify-content-center">
              <div class="col">
                <div class="table-responsive table-responsive-sm">
                  <table
                    class="table table-sm table-bordered table-striped small"
                  >
                    <thead>
                      <tr class="table-month-header-red">
                        <th></th>
                        <th colspan="3" v-for="title in titles">
                          {{ title.head }}
                        </th>
                      </tr>
                    </thead>
                    <tr class="table-month-header-blue">
                      <th>Details</th>
                      <th v-for="Quote in Quotes">{{ Quote.subheads }}</th>
                      <th v-for="Quote in Quotes">{{ Quote.subheads }}</th>
                      <th v-for="Quote in Quotes">{{ Quote.subheads }}</th>
                    </tr>
                    <tbody>
                      <tr v-for="quote in listScorescard">
                        <td>{{ quote.details }}</td>

                        <td>{{ quote.quoteExpected }}</td>
                        <td>{{ quote.quoteActual }}</td>
                        <td>{{ quote.quotePercentage }}</td>

                        <td>{{ quote.appsExpected }}</td>
                        <td>{{ quote.appsActual }}</td>
                        <td>{{ quote.appsPercentage }}</td>

                        <td>{{ quote.dealsExpected }}</td>
                        <td>{{ quote.dealsActual }}</td>
                        <td>{{ quote.dealsPercentage }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!--col end-->
            </div>
            <!--row end-->
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Scorecard Details</b>
              </span>
            </nav>
            <div class="row mt-2 justify-content-center">
              <div class="col">
                <div
                  class="table-responsive table-responsive-sm mb-5"
                  style="height:187px;overflow:auto;"
                >
                  <v-table
                    id="myappsTable"
                    :data="listScores"
                    :currentPage.sync="currentPage"
                    @totalPagesChanged="totalPages = $event"
                    class="table table-sm table-bordered table-striped"
                  >
                    <thead
                      class="table-month-header-blue wrap-text"
                      slot="head"
                    >
                      <v-th sortKey="salesAgentName">Name</v-th>
                      <v-th sortKey="monthName">Month</v-th>
                      <v-th sortKey="year">Year</v-th>
                      <v-th sortKey="scoreName">Score Name</v-th>
                      <v-th sortKey="weightagePercent"
                        >Weighted Percentage</v-th
                      >
                      <v-th sortKey="expectedCount">Expected Count</v-th>
                      <v-th sortKey="actualCount">Actual Count</v-th>
                      <v-th sortKey="scorePercentage">Score %</v-th>
                    </thead>
                    <tbody slot="body" slot-scope="{ displayData }">
                      <tr v-for="(score, index) in displayData" :key="index">
                        <td>{{ score.salesAgentName }}</td>
                        <td>{{ score.monthName }}</td>
                        <td>{{ score.year }}</td>
                        <td>{{ score.scoreName }}</td>
                        <td>{{ score.weightagePercent }}</td>
                        <td>{{ score.expectedCount }}</td>
                        <td>{{ score.actualCount }}</td>
                        <td>{{ score.scorePercentage }}</td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
              <!--col end-->
            </div>
            <!--row end-->

            <div></div>

            <div></div>
          </div>

          <!-- End of the code for this screen here -->
        </div>
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpemployee from '../js/http-employee.js'
import httpdeals from '../js/http-dealstracking.js'
import userjson from '../json/users.json'
import aggregatejson from '../json/aggregate.json'
import moment from 'moment'
import activitiesjson from '../json/activities.json'
export default {
  components: {
    MainMenu,
    TopHeader,

    BottomFooter
  },
  data () {
    return {
      salesAgentOnly: false,
      employeeList: [],
      // listQuotes:aggregatejson,
      listScores: [],
      currentPage: 1,
      totalPages: 0,
      listScorescard: [],
      months: [
        { month: 'All' },
        { month: 'Jan' },
        { month: 'Feb' },
        { month: 'Mar' },
        { month: 'Apr' },
        { month: 'May' },
        { month: 'Jun' },
        { month: 'Jul' },
        { month: 'Aug' },
        { month: 'Sep' },
        { month: 'Oct' },
        { month: 'Nov' },
        { month: 'Dec' }
      ],
      years: [
        { year: 'All' },
        { year: '2015' },
        { year: '2016' },
        { year: '2017' },
        { year: '2018' },
        { year: '2019' },
        { year: '2020' },
        { year: '2021' },
        { year: '2022' }
      ],
      titles: [
        {
          head: 'Quotes'
        },
        {
          head: 'Apps'
        },
        {
          head: 'Deals'
        }
      ],
      Quotes: [
        {
          subheads: 'Expected'
        },
        {
          subheads: 'Actual'
        },
        {
          subheads: 'Percentage (%)'
        }
      ],
      selectedagent: 'All',
      selectedmonth: 'All',
      selectedyear: 'All',
      heads: [
        { name: 'Name' },
        { name: 'Month' },
        { name: 'Year' },
        { name: 'Score Name' },
        { name: 'Weighted Percentage' },
        { name: 'Expected Count' },
        { name: 'Actual Count' },
        { name: 'Score %' }
      ]
    }
  },
  methods: {
    searchScorecardDetails: function () {
      var empId, monthName, year
      if (this.selectedagent != 'All') {
        empId = this.selectedagent
      }
      if (this.selectedmonth != 'All') {
        monthName = this.selectedmonth
      }
      if (this.selectedyear != 'All') {
        year = this.selectedyear
      }
      httpdeals
        .get('/score/details/summary', {
          params: {
            agentId: empId,
            month: monthName,
            year: year
          }
        })
        .then(response => {
          if (this.$session.get('user_role') == 'SR') {
            this.listScorescard = response.data
            this.listScorescard[0].details = this.$session.get('user_name')
          } else {
            this.listScorescard = response.data
            console.log(JSON.stringify(this.listScorescard.details))
          }
        })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
      // this.retrieveScoreDetails()
    },

    searchScoreDetails: function () {
      var empId, monthName, year
      if (this.selectedagent != 'All') {
        empId = this.selectedagent
      }
      if (this.selectedmonth != 'All') {
        monthName = this.selectedmonth
      }
      if (this.selectedyear != 'All') {
        year = this.selectedyear
      }
      httpdeals
        .get('/score/details/search', {
          params: {
            agentId: empId,
            month: monthName,
            year: year
          }
        })
        .then(response => {
          this.listScores = response.data
        })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
      // this.retrieveScoreDetails()
      this.searchScorecardDetails()
    },
    // retrieveScoreDetails () {

    // httpdeals httpdeals.get('/score/summary').then(response => {

    // this.listQuotes=response.data
    // console.log(JSON.stringify(this.listQuotes))
    // })
    //  .catch(e => {
    //   console.log(e)
    //  this.errors.push(e)
    // })
    // },
    retrieveEmployeeList () {
      httpemployee
        .get('/employee/salesrep')
        .then(response => {
          this.employeeList = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    fetchData () {
      console.log()
      this.retrieveEmployeeList()

      if (this.$session.get('user_role') == 'SR') {
        this.selectedagent = this.$session.get('employee_id')
        this.selectedmonth = moment().format('MMM')
        this.selectedyear = moment().format('YYYY')
        this.salesAgentOnly = true
      } else {
        this.selectedagent = 'All'
        this.selectedmonth = moment().format('MMM')
        this.selectedyear = moment().format('YYYY')
        this.salesAgentOnly = false
      }
      this.searchScoreDetails()
      this.searchScorecardDetails()
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#performance').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.fetchData()
    this.myFunction()
    this.menuheight()
  }
}
</script>
<style scoped>
.wrap-text {
  white-space: nowrap;
}
</style>
